import { useRouter } from 'next/router';

import { Paragraph, Tooltip, TriggerText } from '@zillow/constellation-10';
import { useRentalManagerUserFreemiumAnalyticsWebApiHandler_overview } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { RentalManagerFreemiumAnalyticsFilterType } from '@zg-rentals/ts-rental-manager-api-client';

import { usePremiumAnalyticsContext } from '../PremiumAnalyticsContext';
import { formatSearchString } from '../../../utils/premiumAnalyticsUtils';
import propertyUtils from '../../../utils/propertyUtils';

type ActiveCompsTooltipProps = {
  triggerText: string;
};

const ActiveCompsTooltip = ({ triggerText }: ActiveCompsTooltipProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { filters } = usePremiumAnalyticsContext();
  const { beds, filterType, propertyType } = filters;

  const { data: overviewData } = useRentalManagerUserFreemiumAnalyticsWebApiHandler_overview(
    {
      listingAlias,
      filterType,
    },
    { enabled: !!listingAlias, staleTime: Infinity },
  );

  if (!overviewData) {
    return null;
  }

  const { formattedCityState } = overviewData ? propertyUtils.formatAddress(overviewData) : { formattedCityState: '' };
  const searchArea =
    filterType === RentalManagerFreemiumAnalyticsFilterType.ZIP ? overviewData.zip : formattedCityState;
  const searchString = searchArea ? formatSearchString(beds, propertyType, searchArea, false) : '';

  return (
    <Tooltip.Root placement="top">
      <Tooltip.Trigger>
        <TriggerText>{triggerText}</TriggerText>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content>
          <Paragraph>{`Matching your filters for ${searchString}`}</Paragraph>
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};

export default ActiveCompsTooltip;
